import { Tooltip } from '@material-ui/core';
import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import { ReactComponent as ClassNoData } from 'assets/icons/class_noResult.svg';
import { formatDate } from 'helper/dateFormat';
import { numberFormat } from 'helper/numberFormat';
import React from 'react';
import './formInformation.scss';

const InternalDrawer = ({ formik }) => {

  const calculateProductPrice = (price) => {
    if((price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'on registration') && price?.variant) {
      const amounts = Object.values(price?.variantInfo).map(product => product.amount || 0);
      const minAmount = Math.min(...amounts);
      const maxAmount = Math.max(...amounts);
      return `${numberFormat({number:+minAmount, decimal: 2, style: 'currency'})} - ${numberFormat({number:+maxAmount, decimal: 2, style: 'currency'})}`;
    } else if(price?.type?.toLowerCase() === 'open amount') {
      return `${numberFormat({number:+price?.minAmount, decimal: 2, style: 'currency'})}`;
    } else {
      return `${numberFormat({number:+price?.amount, decimal: 2, style: 'currency'})}`;
    }
  }


  return (
    <>
      {formik.currentStepIndex !== 0 ? (
        <div className="internal_drawer">
          <h2 className="drawer_title">
            <div>Your Form</div>
          </h2>
          <div className="drawer_classInfo">
            <div className="class_info_title">
              <h3>Form Name</h3>
              <h3>Submission Starts-ends</h3>
            </div>
            <div className="class_info_value justify-content-end">
              <p>{formik.values?.formName}</p>
              {formik.values?.formStartDate && (
                <p>
                  {formatDate({date:formik.values?.formStartDate, formatType: "defaultWithUTC"})} -{' '}
                  
                  {formik.values?.alwaysAvailable ? "Always Available" 
                  : formatDate({date:formik.values?.formEndDate, formatType: "defaultWithUTC"})}
                </p>
              )}
            </div>
          </div>
          {formik.values?.description !== '<p></p>\n' && (
            <div className="drawer_description">
              <h3>Description</h3>
              <p
                dangerouslySetInnerHTML={{ __html: formik.values?.description }}
              ></p>
            </div>
          )}
       
              <div className="non_member_allowing mt-4">
                <InfoIcon className="mr-3" />
                <p>
                {formik.values?.allowNonMembers ? "Non" : "Only"} members are eligible to register for this Form
                </p>
              </div>
          
          <div className="price_section mt-10">
            {formik.values?.prices?.length > 0 &&
              formik.values?.prices?.map((price) => (
                <div className="subtotal mb-4">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <p style={{ margin: 0 }}>
                      {price?.title}
                      {(price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'addons') && <span className="price_section-optional">(Add-ons)</span>}
                    </p>
                    {price?.isRecurring && (
                      <Tooltip title="Monthly recurring" placement="top">
                        <span className="recurring_indicator" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', padding: '7px 9px', borderRadius: '6px' }}>
                          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 0C2.02085 0 0 2.02085 0 4.5C0 6.9795 2.02085 9 4.5 9C6.76904 9 8.65385 7.308 8.95673 5.1165C8.96954 5.04742 8.96819 4.97646 8.95277 4.90791C8.93736 4.83937 8.90819 4.77466 8.86703 4.71772C8.82588 4.66078 8.7736 4.61278 8.71336 4.57663C8.65311 4.54048 8.58616 4.51693 8.51655 4.50741C8.44694 4.4979 8.37612 4.5026 8.30838 4.52125C8.24064 4.5399 8.1774 4.5721 8.12247 4.6159C8.06754 4.65971 8.02207 4.71421 7.98881 4.7761C7.95556 4.83798 7.93521 4.90598 7.929 4.97596C7.69604 6.66173 6.25535 7.96154 4.5 7.96154C2.58231 7.96154 1.03846 6.41804 1.03846 4.5C1.03846 2.58231 2.58231 1.03846 4.5 1.03846C5.62015 1.03846 6.61465 1.56981 7.24777 2.39054L6.63092 3.00738C6.579 3.05931 6.5655 3.14273 6.58765 3.21265C6.60842 3.28258 6.66692 3.32758 6.73927 3.34246C7.67285 3.52592 8.74938 3.44492 8.79438 3.43973C8.84 3.43151 8.88176 3.40881 8.91346 3.375C8.94462 3.34454 8.97231 3.31269 8.97854 3.26665C8.98373 3.22165 9.06508 2.13577 8.88092 1.20081C8.87544 1.166 8.8604 1.13339 8.83748 1.10663C8.81456 1.07986 8.78466 1.05998 8.75112 1.04919C8.6805 1.02773 8.59742 1.04054 8.54585 1.09246L7.98335 1.65496C7.15777 0.647308 5.90088 0 4.5 0Z" fill="#3C4467"/>
                          </svg>
                        </span>
                      </Tooltip>
                    )}
                  </div>
                  <h4>{calculateProductPrice(price)}</h4>
                </div>
              ))}

            {formik.values?.discount?.length > 0 &&
              formik.values?.discount?.map((dis) => (
                <div className="discount mb-4">
                  <p>
                    {(dis?.discount_type === 'Date' ||  dis?.discount_type === 'date') &&
                    dis?.start_date &&
                    dis?.end_date
                      ? `${dis?.discount_name} | ${formatDate({date:dis?.start_date, formatType: "defaultWithUTC"})}-${formatDate({date:dis?.end_date, formatType: "defaultWithUTC"})}`
                      : dis?.discount_name}
                  </p>
                  <h4>- {dis?.price_type === 'percentage' ? `${dis?.value}%` : `${numberFormat({number:+dis?.value, decimal: 2, style: 'currency'})}`}</h4>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div className="no_date">
          <ClassNoData />
          {/* <p className="no_date_p">No Results Yet</p> */}
        </div>
      )}
    </>
  );
};

export default InternalDrawer;

